import { INVOICE_NUMBER_MASTER_TYPES } from '../actions/invoiceNumberMasterActions';

const initialState = {
  // Masters data
  masters: [],
  currentFYMaster: [],
  currentMaster: null,
  
  // Loading states
  mastersLoading: false,
  currentFYLoading: false,
  masterLoading: false,
  createLoading: false,
  updateLoading: false,
  deleteLoading: false,
  generateLoading: false,
  financialYearLoading: false,
  
  // Error states
  mastersError: null,
  currentFYError: null,
  masterError: null,
  createError: null,
  updateError: null,
  deleteError: null,
  generateError: null,
  financialYearError: null,
  
  // Pagination
  pagination: {
    total: 0,
    page: 1,
    limit: 10,
    pages: 0
  },
  
  // Current financial year
  currentFinancialYear: null,
  
  // Generated invoice number
  generatedInvoiceNumber: null
};

const invoiceNumberMasterReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch all masters
    case INVOICE_NUMBER_MASTER_TYPES.FETCH_INVOICE_NUMBER_MASTERS_REQUEST:
      return {
        ...state,
        mastersLoading: true,
        mastersError: null
      };
    
    case INVOICE_NUMBER_MASTER_TYPES.FETCH_INVOICE_NUMBER_MASTERS_SUCCESS:
      return {
        ...state,
        mastersLoading: false,
        masters: action.payload.data,
        pagination: action.payload.pagination,
        mastersError: null
      };
    
    case INVOICE_NUMBER_MASTER_TYPES.FETCH_INVOICE_NUMBER_MASTERS_FAILURE:
      return {
        ...state,
        mastersLoading: false,
        mastersError: action.payload
      };
    
    // Fetch current FY masters
    case INVOICE_NUMBER_MASTER_TYPES.FETCH_CURRENT_FY_MASTERS_REQUEST:
      return {
        ...state,
        currentFYLoading: true,
        currentFYError: null
      };
    
    case INVOICE_NUMBER_MASTER_TYPES.FETCH_CURRENT_FY_MASTERS_SUCCESS:
      return {
        ...state,
        currentFYLoading: false,
        currentFYMaster: action.payload.data,
        currentFinancialYear: action.payload.current_financial_year,
        currentFYError: null
      };
    
    case INVOICE_NUMBER_MASTER_TYPES.FETCH_CURRENT_FY_MASTERS_FAILURE:
      return {
        ...state,
        currentFYLoading: false,
        currentFYError: action.payload
      };
    
    // Fetch master by ID
    case INVOICE_NUMBER_MASTER_TYPES.FETCH_MASTER_BY_ID_REQUEST:
      return {
        ...state,
        masterLoading: true,
        masterError: null
      };
    
    case INVOICE_NUMBER_MASTER_TYPES.FETCH_MASTER_BY_ID_SUCCESS:
      return {
        ...state,
        masterLoading: false,
        currentMaster: action.payload.data,
        masterError: null
      };
    
    case INVOICE_NUMBER_MASTER_TYPES.FETCH_MASTER_BY_ID_FAILURE:
      return {
        ...state,
        masterLoading: false,
        masterError: action.payload
      };
    
    // Create master
    case INVOICE_NUMBER_MASTER_TYPES.CREATE_MASTER_REQUEST:
      return {
        ...state,
        createLoading: true,
        createError: null
      };
    
    case INVOICE_NUMBER_MASTER_TYPES.CREATE_MASTER_SUCCESS:
      return {
        ...state,
        createLoading: false,
        masters: [...state.masters, action.payload.data],
        createError: null
      };
    
    case INVOICE_NUMBER_MASTER_TYPES.CREATE_MASTER_FAILURE:
      return {
        ...state,
        createLoading: false,
        createError: action.payload
      };
    
    // Update master
    case INVOICE_NUMBER_MASTER_TYPES.UPDATE_MASTER_REQUEST:
      return {
        ...state,
        updateLoading: true,
        updateError: null
      };
    
    case INVOICE_NUMBER_MASTER_TYPES.UPDATE_MASTER_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        masters: state.masters.map(master => 
          master.id === action.payload.data.id ? action.payload.data : master
        ),
        currentMaster: action.payload.data,
        updateError: null
      };
    
    case INVOICE_NUMBER_MASTER_TYPES.UPDATE_MASTER_FAILURE:
      return {
        ...state,
        updateLoading: false,
        updateError: action.payload
      };
    
    // Delete master
    case INVOICE_NUMBER_MASTER_TYPES.DELETE_MASTER_REQUEST:
      return {
        ...state,
        deleteLoading: true,
        deleteError: null
      };
    
    case INVOICE_NUMBER_MASTER_TYPES.DELETE_MASTER_SUCCESS:
      return {
        ...state,
        deleteLoading: false,
        masters: state.masters.filter(master => master.id !== action.payload),
        deleteError: null
      };
    
    case INVOICE_NUMBER_MASTER_TYPES.DELETE_MASTER_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        deleteError: action.payload
      };
    
    // Generate next invoice number
    case INVOICE_NUMBER_MASTER_TYPES.GENERATE_NEXT_INVOICE_NUMBER_REQUEST:
      return {
        ...state,
        generateLoading: true,
        generateError: null
      };
    
    case INVOICE_NUMBER_MASTER_TYPES.GENERATE_NEXT_INVOICE_NUMBER_SUCCESS:
      return {
        ...state,
        generateLoading: false,
        generatedInvoiceNumber: action.payload.data,
        generateError: null
      };
    
    case INVOICE_NUMBER_MASTER_TYPES.GENERATE_NEXT_INVOICE_NUMBER_FAILURE:
      return {
        ...state,
        generateLoading: false,
        generateError: action.payload
      };
    
    // Get current financial year
    case INVOICE_NUMBER_MASTER_TYPES.GET_CURRENT_FINANCIAL_YEAR_REQUEST:
      return {
        ...state,
        financialYearLoading: true,
        financialYearError: null
      };
    
    case INVOICE_NUMBER_MASTER_TYPES.GET_CURRENT_FINANCIAL_YEAR_SUCCESS:
      return {
        ...state,
        financialYearLoading: false,
        currentFinancialYear: action.payload.data.financial_year,
        financialYearError: null
      };
    
    case INVOICE_NUMBER_MASTER_TYPES.GET_CURRENT_FINANCIAL_YEAR_FAILURE:
      return {
        ...state,
        financialYearLoading: false,
        financialYearError: action.payload
      };
    
    // Clear error
    case INVOICE_NUMBER_MASTER_TYPES.CLEAR_MASTER_ERROR:
      return {
        ...state,
        mastersError: null,
        currentFYError: null,
        masterError: null,
        createError: null,
        updateError: null,
        deleteError: null,
        generateError: null,
        financialYearError: null
      };
    
    // Clear data
    case INVOICE_NUMBER_MASTER_TYPES.CLEAR_MASTER_DATA:
      return {
        ...initialState
      };
    
    default:
      return state;
  }
};

export default invoiceNumberMasterReducer;
